import './Materiais.css'
import Header from '../../componentes/js/Header';
import Footer from '../../componentes/js/Footer';
import { useEffect, useState } from 'react';

const Materiais = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
      setIsMobile(true);
    }
  }, []);

  return (
    <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
      <Header />
      <main>
      <div className='conteudo' style={{display: 'flex', flexDirection: 'column', width: 'auto', margin: '10px 15px'}}>
        <div style={{width: '100%'}}>
          <h2 className='titulo-secao' style={{marginBottom: '25px'}}>Fundamental I</h2>
          <div className='imagesMate'>
            <div className='materialClass'>
              <h3>1º Ano Ens. Fundamental I</h3>
              <img src={`assets/images/calendarios/materiais/1ano.png`} alt="Material do 1º Ano do Ensino Fundamental I"></img>
            </div>
            <div className='materialClass'>
              <h3>2º Ano Ens. Fundamental I</h3>
              <img src={`assets/images/calendarios/materiais/2ano.png`} alt="Material do 2º Ano do Ensino Fundamental I"></img>
            </div>
            <div className='materialClass'>
              <h3>3º Ano Ens. Fundamental I</h3>
              <img src={`assets/images/calendarios/materiais/3ano.png`} alt="Material do 3º Ano do Ensino Fundamental I"></img>
            </div>
            <div style={{marginTop: '20px'}} className='materialClass'>
              <h3>4º Ano Ens. Fundamental I</h3>
              <img src={`assets/images/calendarios/materiais/4ano.png`} alt="Material do 4º Ano do Ensino Fundamental I"></img>
            </div>
            <div style={{marginTop: '20px'}} className='materialClass'>
              <h3>5º Ano Ens. Fundamental I</h3>
              <img src={`assets/images/calendarios/materiais/5ano.png`} alt="Material do 5º Ano do Ensino Fundamental I"></img>
            </div>
          </div>
        </div>
        <div style={{width: '100%'}}>
          <h2 className='titulo-secao' style={{marginBottom: '25px'}}>Fundamental II</h2>
          <div className='imagesMate'>
            <div className='materialClass'>
              <h3>6º Ano Ens. Fundamental II</h3>
              <img src={`assets/images/calendarios/materiais/6ano.jpg`} alt="Material do 6º Ano do Ensino Fundamental II"></img>
            </div>
            <div className='materialClass'>
              <h3>7º Ano Ens. Fundamental II</h3>
              <img src={`assets/images/calendarios/materiais/7ano.jpg`} alt="Material do 7º Ano do Ensino Fundamental II"></img>
            </div>
            <div className='materialClass'>
              <h3>8º Ano Ens. Fundamental II</h3>
              <img src={`assets/images/calendarios/materiais/8ano.jpg`} alt="Material do 8º Ano do Ensino Fundamental II"></img>
            </div>
          </div>
        </div>
      </div>
      </main>
      <Footer />
    </div>
  );
};

export default Materiais;